<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-row class="mt-4">
            <b-col>
              <b-row>
                <b-col>
                  <p class="font-bold">BUSINESS DETAILS</p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                    <tbody>
                    <tr style="border: solid 1px #dedede;">
                      <td class="px-2 py-1 font-bold text-capitalize">Name</td>
                      <td class="px-2 py-1 text-capitalize">{{ task.name || task.companyName || "-" }}</td>
                    </tr>
                    <tr style="border: solid 1px #dedede;">
                      <td class="px-2 py-1 font-bold text-capitalize">Registration Number</td>
                      <td class="px-2 py-1 text-capitalize">{{ task.brn || "-" }}</td>
                    </tr>
                    <tr style="border: solid 1px #dedede;">
                      <td class="px-2 py-1 font-bold text-capitalize">Business Sub Type</td>
                      <td class="px-2 py-1 text-capitalize">{{ formatSubType(primaryAnnualReturn.subType) }}</td>
                    </tr>
                    <tr style="border: solid 1px #dedede;">
                      <td class="px-2 py-1 font-bold text-capitalize">Nature of Business (ISIC)</td>
                      <td class="px-2 py-1">{{ formatIsic(primaryAnnualReturn.isic) }}</td>
                    </tr>
                    <tr style="border: solid 1px #dedede;">
                      <td class="px-2 py-1 font-bold text-capitalize">Postal Address</td>
                      <td class="px-2 py-1 text-capitalize">{{ primaryAnnualReturn.postalAddress || task.postalAddress || "-" }}</td>
                    </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>

              <b-row v-if="showIsicYearTable" class="mt-4">
                <b-col>
                  <b-row>
                    <b-col>
                      <p class="font-bold">NATURE OF BUSINESS BY FILING YEAR</p>
                    </b-col>
                  </b-row>
                  <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                    <thead>
                    <tr class="bg-gray-pale">
                      <th class="px-2 py-1">Year</th>
                      <th class="px-2 py-1">ISIC Code</th>
                      <th class="px-2 py-1">Description</th>
                      <th class="px-2 py-1">Classification</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="(row, idx) in isicYearRows"
                      :key="`isic-${row.year}-${idx}`"
                      style="border: solid 1px #dedede;"
                    >
                      <td class="px-2 py-1">{{ row.year }}</td>
                      <td class="px-2 py-1">{{ row.code || "-" }}</td>
                      <td class="px-2 py-1">{{ row.description || "-" }}</td>
                      <td class="px-2 py-1">{{ row.breakdown || "-" }}</td>
                    </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row>
            <b-col>
              <div class="flex h-full" style="cursor: pointer;">
                <div :class="[(currentRoute === 'membership') ? 'menu-item-active' : 'menu-item']" @click="select('membership')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Partners</div>
                  </div>
                </div>
                <div :class="[(currentRoute === 'address') ? 'menu-item-active' : 'menu-item']" @click="select('address')">
                  <div class="flex mt-6">
                    <div style="font-size: 14px">Address</div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-4" v-if="currentRoute === 'address'">
            <b-col>
              <b-progress
                v-if="loadingYearDetails"
                value="100"
                variant="#007ac5"
                height="0.2rem"
                animated
                class="mb-2"
              ></b-progress>

              <b-row v-if="!loadingYearDetails && addressBlocks.length === 0">
                <b-col cols="12" class="text-gray">
                  No address information returned for this filing.
                </b-col>
              </b-row>

              <b-row v-for="(block, idx) in addressBlocks" :key="idx" class="mb-3">
                <b-col>
                  <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                    <thead>
                      <tr class="bg-gray-pale">
                        <td colspan="12" class="px-2 py-2 font-bold text-gray text-uppercase">
                          {{ block.title }}
                        </td>
                      </tr>
                    </thead>
                  </table>
                  <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                    <tbody>
                      <tr style="border: solid 1px #dedede;" v-for="(row, rIdx) in block.rows" :key="rIdx">
                        <td class="px-2 py-1 font-bold text-capitalize" style="width: 40%">{{ row.label }}</td>
                        <td class="px-2 py-1">{{ row.value || "-" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="mt-4" v-if="currentRoute === 'membership'">
            <b-col>
              <b-progress
                v-if="loadingYearDetails"
                value="100"
                variant="#007ac5"
                height="0.2rem"
                animated
                class="mb-2"
              ></b-progress>

              <b-row v-if="!loadingYearDetails && partnerGroups.length === 0">
                <b-col cols="12" class="text-gray">
                  No partners returned for this filing.
                </b-col>
              </b-row>

              <b-row v-for="(group, gIdx) in partnerGroups" :key="gIdx" class="mb-4">
                <b-col>
                  <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                    <thead>
                      <tr class="bg-gray-pale">
                        <td colspan="12" class="px-2 py-2 font-bold text-gray text-uppercase">
                          Partners for {{ group.year }}
                        </td>
                      </tr>
                    </thead>
                  </table>
                  <table class="min-w-full leading-normal text-gray" style="border: solid 1px #dedede;">
                    <thead>
                      <tr class="bg-white">
                        <th class="px-2 py-1 text-uppercase">#</th>
                        <th class="px-2 py-1 text-uppercase">Name</th>
                        <th class="px-2 py-1 text-uppercase">Type</th>
                        <th class="px-2 py-1 text-uppercase">ID / BRN</th>
                        <th
                          v-if="groupHasCorporatePartner(group.partners)"
                          class="px-2 py-1 text-uppercase"
                        >
                          Country of Origin
                        </th>
                        <th
                          v-if="groupHasCorporatePartner(group.partners)"
                          class="px-2 py-1 text-uppercase"
                        >
                          Date of Incorporation
                        </th>
                        <th class="px-2 py-1 text-uppercase">Phone</th>
                        <th class="px-2 py-1 text-uppercase">Email</th>
                        <th class="px-2 py-1 text-uppercase">Postal Address</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(p, pIdx) in group.partners"
                        :key="p.id || pIdx"
                        style="border: solid 1px #dedede;"
                      >
                        <td class="px-2 py-1">{{ pIdx + 1 }}.</td>
                        <td class="px-2 py-1 text-capitalize">{{ partnerName(p) }}</td>
                        <td class="px-2 py-1 text-uppercase">{{ (p.entityType || partnerEntityType(p) || "-").toString() }}</td>
                        <td class="px-2 py-1 text-uppercase">{{ partnerId(p) || "-" }}</td>
                        <td
                          v-if="groupHasCorporatePartner(group.partners)"
                          class="px-2 py-1 text-capitalize"
                        >
                          {{ partnerCountryOfOrigin(p) || "-" }}
                        </td>
                        <td
                          v-if="groupHasCorporatePartner(group.partners)"
                          class="px-2 py-1"
                        >
                          {{ partnerDateOfIncorporation(p) || "-" }}
                        </td>
                        <td class="px-2 py-1">{{ partnerPhone(p) || "-" }}</td>
                        <td class="px-2 py-1">{{ partnerEmail(p) || "-" }}</td>
                        <td class="px-2 py-1 text-capitalize">{{ partnerPostalAddress(p) || "-" }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {api} from "@/app/services/api.service";

const HIDDEN_DETAIL_KEYS = new Set([
  "id",
  "userid",
  "businessid",
  "isicid",
  "partnerid",
  "taskid",
  "queueid",
  "createdat",
  "updatedat",
  "editable",
  "entitytype",
  "status",
  "years",
  "brn",
  "name",
  "trackingnumber",
  "trackingno",
  "annualreturns",
  "attachments",
  "requiredattachments",
  "partners",
  "isic",
  "subtype",
  "parentid",
])

export default {
  name: "BusinessAnnualReturnForms",
  props: {
    task: Object,
    trackingNumber: String,
  },
  data(){
    return{
      currentRoute: "membership",
      loadingYearDetails: false,
      yearDetailsByYear: {},
    }
  },
  mounted(){
    this.loadYearDetails()
  },
  computed:{
    effectiveTrackingNumber(){
      const task = this.task && typeof this.task === "object" ? this.task : {}
      return this.trackingNumber || task.trackingNumber || task.trackingNo || null
    },
    annualReturnsList(){
      if(this.task && Array.isArray(this.task.annualReturns)){
        return this.task.annualReturns
      }
      return []
    },
    enrichedAnnualReturns(){
      return this.annualReturnsList.map((annualReturn) => {
        const year = annualReturn && annualReturn.year != null ? annualReturn.year : null
        const yearDetails = year != null ? this.yearDetailsByYear[year] : null
        return {
          ...annualReturn,
          ...(yearDetails && typeof yearDetails === "object" ? yearDetails : {}),
        }
      })
    },
    primaryAnnualReturn(){
      const list = this.enrichedAnnualReturns
      if(list.length === 0){
        return {}
      }
      const sorted = [...list].sort((a, b) => Number(b.year) - Number(a.year))
      return sorted[0] || {}
    },
    isicYearRows(){
      return this.enrichedAnnualReturns
        .map((annualReturn) => {
          const isic = annualReturn && annualReturn.isic ? annualReturn.isic : null
          return {
            year: annualReturn.year,
            code: isic && isic.code ? isic.code : null,
            description: isic && isic.description ? isic.description : null,
            breakdown: isic && Array.isArray(isic.breakdown) ? isic.breakdown.join(" > ") : null,
          }
        })
        .filter((row) => row.year != null)
        .sort((a, b) => Number(a.year) - Number(b.year))
    },
    showIsicYearTable(){
      if(this.isicYearRows.length <= 1){
        return false
      }
      const first = this.isicYearRows[0]
      return this.isicYearRows.some((row) => {
        return row.code !== first.code
          || row.description !== first.description
          || row.breakdown !== first.breakdown
      })
    },
    partnerGroups(){
      return this.enrichedAnnualReturns
        .map((annualReturn) => {
          const year = annualReturn && annualReturn.year != null ? annualReturn.year : "-"
          const partners = annualReturn && Array.isArray(annualReturn.partners) ? annualReturn.partners : []
          return { year, partners }
        })
        .filter((group) => Array.isArray(group.partners) && group.partners.length > 0)
    },
    addressBlocks(){
      const task = this.task && typeof this.task === "object" ? this.task : {}
      const blocks = []
      const groupedYears = []

      const primaryRows = this.collectAddressRows(task)
      const primarySignature = this.rowsSignature(primaryRows)
      if(primaryRows.length){
        blocks.push({
          title: "Business Address",
          rows: primaryRows,
        })
      }

      this.enrichedAnnualReturns.forEach((annualReturn) => {
        const year = annualReturn && annualReturn.year != null ? annualReturn.year : null
        if(year == null){
          return
        }

        const rows = this.collectAddressRows(annualReturn)
        if(rows.length === 0){
          return
        }

        const signature = this.rowsSignature(rows)
        if(signature === primarySignature){
          return
        }

        const existingGroup = groupedYears.find((group) => group.signature === signature)
        if(existingGroup){
          existingGroup.years.push(year)
          return
        }

        groupedYears.push({
          years: [year],
          rows,
          signature,
        })
      })

      groupedYears.forEach((group) => {
        const title = group.years.length === 1
          ? `Filing Year ${group.years[0]}`
          : `Filing Years ${group.years.join(", ")}`

        blocks.push({
          title,
          rows: group.rows,
        })
      })

      return blocks
    },
  },
  watch:{
    task:{
      deep: true,
      handler(){
        this.yearDetailsByYear = {}
        this.loadYearDetails()
      },
    },
    trackingNumber(){
      this.yearDetailsByYear = {}
      this.loadYearDetails()
    },
  },
  methods:{
    select(route){
      this.currentRoute = route
      if(route === "address" || route === "membership"){
        this.loadYearDetails()
      }
    },
    formatSubType(value){
      if(typeof value !== "string" || !value.trim()){
        return "-"
      }
      return value.replaceAll("-", " ")
    },
    formatIsic(isic){
      if(!isic || typeof isic !== "object"){
        return "-"
      }

      const parts = []
      if(isic.code){
        parts.push(String(isic.code))
      }
      if(isic.description){
        parts.push(String(isic.description))
      }
      if(Array.isArray(isic.breakdown) && isic.breakdown.length){
        parts.push(isic.breakdown.join(" > "))
      }

      return parts.length ? parts.join(" - ") : "-"
    },
    isHiddenDetailKey(key){
      return HIDDEN_DETAIL_KEYS.has(String(key || "").toLowerCase())
    },
    isUuidValue(value){
      if(typeof value !== "string"){
        return false
      }
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.trim())
    },
    normalizeRowValue(value){
      if(value == null){
        return ""
      }
      if(typeof value === "string" || typeof value === "number" || typeof value === "boolean"){
        return String(value).trim()
      }
      return ""
    },
    rowsSignature(rows){
      return rows
        .map((row) => `${row.label}:${row.value}`)
        .join("|")
    },
    dedupeRows(rows){
      const seen = new Set()
      return rows.filter((row) => {
        const key = `${row.label}:${row.value}`
        if(seen.has(key)){
          return false
        }
        seen.add(key)
        return true
      })
    },
    collectAddressRows(source){
      if(!source || typeof source !== "object"){
        return []
      }

      const rows = [
        { label: "Postal Address", value: this.normalizeRowValue(source.postalAddress) },
        { label: "Phone", value: this.normalizeRowValue(source.phone) },
        { label: "Email", value: this.normalizeRowValue(source.email) },
        ...this.physicalAddressRows(source.physicalAddress),
        ...this.physicalAddressRows(source.registeredPhysicalAddress),
        ...this.buildAddressRows(source.address),
      ].filter((row) => row.value !== "")

      return this.dedupeRows(rows)
    },
    buildAddressRows(source){
      if(!source){
        return []
      }

      if(typeof source === "string"){
        return [{ label: "Address", value: source }]
      }

      if(typeof source !== "object"){
        return []
      }

      if(source.plot || source.street || source.description){
        return [
          { label: "Plot", value: source.plot },
          { label: "Street", value: source.street },
          { label: "Postal Address", value: source.postalAddress },
          { label: "Description", value: source.description },
        ].filter((row) => this.normalizeRowValue(row.value) !== "")
      }

      return Object.keys(source)
        .filter((key) => {
          if(this.isHiddenDetailKey(key)){
            return false
          }
          const value = source[key]
          if(value == null || value === "" || typeof value === "object"){
            return false
          }
          if(this.isUuidValue(value)){
            return false
          }
          return true
        })
        .map((key) => ({
          label: key.replaceAll("_", " "),
          value: source[key],
        }))
    },
    physicalAddressRows(address){
      if(!address || typeof address !== "object"){
        return []
      }

      const adminUnits = [
        { label: "Country", value: address.country && address.country.name },
        { label: "Region", value: address.region ? address.region.name : '' },
        { label: "District", value: address.district && address.district.name },
        { label: "Sub County", value: address.subcounty && address.subcounty.name },
        { label: "Parish", value: address.parish && address.parish.name },
        { label: "Village", value: address.village && address.village.name },
      ].filter((row) => row.value)

      if(adminUnits.length){
        return adminUnits
      }

      return this.buildAddressRows(address)
    },
    async loadYearDetails(){
      const trackingNumber = this.effectiveTrackingNumber
      if(!trackingNumber || this.annualReturnsList.length === 0){
        return
      }

      const yearsToFetch = this.annualReturnsList
        .map((annualReturn) => annualReturn.year)
        .filter((year) => year != null && !this.yearDetailsByYear[year])

      if(yearsToFetch.length === 0){
        return
      }

      this.loadingYearDetails = true
      try {
        await Promise.all(yearsToFetch.map(async (year) => {
          try {
            const response = await api().get(
              `/business-registration-v2/annual-return-forms/${encodeURIComponent(trackingNumber)}/return/${year}`
            )
            const payload = response?.data?.data ?? response?.data ?? null
            if(payload && typeof payload === "object"){
              this.$set(this.yearDetailsByYear, year, payload)
            }
          } catch (error) {
            return null
          }
        }))
      } finally {
        this.loadingYearDetails = false
      }
    },
    partnerCorporate(partner){
      return partner && partner.corporate && typeof partner.corporate === "object" ? partner.corporate : null
    },
    partnerIndividual(partner){
      return partner && partner.individual && typeof partner.individual === "object" ? partner.individual : null
    },
    firstPartnerValue(...values){
      for(const value of values){
        const normalized = this.normalizeRowValue(value)
        if(normalized !== ""){
          return normalized
        }
      }
      return ""
    },
    groupHasCorporatePartner(partners){
      if(!Array.isArray(partners)){
        return false
      }
      return partners.some((partner) => this.partnerEntityType(partner) === "CORPORATE")
    },
    partnerEntityType(partner){
      if(!partner || typeof partner !== "object") return null
      if(partner.entityType){
        return partner.entityType
      }
      if(partner.individual) return "INDIVIDUAL"
      if(partner.corporate) return "CORPORATE"
      return null
    },
    partnerName(partner){
      if(!partner || typeof partner !== "object") return ""

      const corporate = this.partnerCorporate(partner)
      if(corporate){
        const registeredName = this.firstPartnerValue(
          corporate.registeredName,
          corporate.name,
          partner.name,
        )
        if(registeredName){
          return registeredName
        }
      }

      const topLevelName = this.firstPartnerValue(partner.name)
      if(topLevelName){
        return topLevelName
      }

      const individual = this.partnerIndividual(partner)
      if(individual){
        return [individual.givenName, individual.surName, individual.middleName].filter(Boolean).join(" ")
      }

      return ""
    },
    partnerId(partner){
      const corporate = this.partnerCorporate(partner)
      if(corporate){
        const brn = this.firstPartnerValue(corporate.brn)
        if(brn){
          return brn
        }
      }

      const individual = this.partnerIndividual(partner)
      if(individual && (individual.idType || individual.idNumber)){
        return [individual.idType, individual.idNumber].filter(Boolean).join(": ")
      }

      return null
    },
    partnerCountryOfOrigin(partner){
      const corporate = this.partnerCorporate(partner)
      if(!corporate){
        return null
      }
      return this.firstPartnerValue(corporate.countryOfOrigin) || null
    },
    partnerDateOfIncorporation(partner){
      const corporate = this.partnerCorporate(partner)
      if(!corporate){
        return null
      }
      return this.firstPartnerValue(corporate.dateOfIncorporation) || null
    },
    partnerPhone(partner){
      const individual = this.partnerIndividual(partner)
      if(individual){
        const phone = this.firstPartnerValue(individual.phoneNumber)
        if(phone){
          return phone
        }
      }

      const corporate = this.partnerCorporate(partner)
      if(corporate){
        return this.firstPartnerValue(corporate.primaryPhone, corporate.phone) || null
      }

      return null
    },
    partnerEmail(partner){
      const individual = this.partnerIndividual(partner)
      if(individual){
        const email = this.firstPartnerValue(individual.email)
        if(email){
          return email
        }
      }

      const corporate = this.partnerCorporate(partner)
      if(corporate){
        return this.firstPartnerValue(corporate.primaryEmail, corporate.email) || null
      }

      return null
    },
    partnerPostalAddress(partner){
      const individual = this.partnerIndividual(partner)
      if(individual){
        const postalAddress = this.firstPartnerValue(individual.postalAddress)
        if(postalAddress){
          return postalAddress
        }
      }

      const corporate = this.partnerCorporate(partner)
      if(corporate){
        return this.firstPartnerValue(corporate.postalAddress) || null
      }

      return null
    },
  },
};
</script>

<style scoped>

th, td {
  font-size: 12px;
}

</style>
